import queryString from "query-string";
import { RootState } from "src/store";

import { closeDetails, setPaneTab, showDetails, updateSearchQuery } from "@dashboard/devices/store";
import { isAnyOf, ListenerMiddlewareInstance, UnsubscribeListener } from "@reduxjs/toolkit";

export const initUrlMiddleware = (listenerMiddleware: ListenerMiddlewareInstance): UnsubscribeListener => {
    return listenerMiddleware.startListening({
        matcher: isAnyOf(updateSearchQuery, showDetails, setPaneTab, closeDetails),
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState() as RootState;
            const details = state.devices.details;
            const url = window.location.href;
            const options = { skipEmptyString: true, skipNull: true };
            const query = {
                search: state.devices.search.query,
                licenseId: details?.type === "license" ? details.selectedId : null,
                groupId: details?.type === "group" ? details.selectedId : null,
                tab: details?.selectedId ? state.devices.pane.tab : null,
            };

            if (new URL(url).pathname.includes("/dashboard/devices")) {
                window.history.replaceState(window.history.state, "", queryString.stringifyUrl({ url, query }, options));
            }
        },
    });
};
